/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDeploy = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <style>{'.ico-deploy_svg__st0{fill:currentcolor}'}</style>
    <path
      className="ico-deploy_svg__st0"
      d="M13.7 7.2c-1.7 0-3.1 1.4-3.1 3.1s1.4 3.1 3.1 3.1 3.1-1.4 3.1-3.1-1.4-3.1-3.1-3.1zm0 4.1c-.6 0-1.1-.5-1.1-1.1s.5-1.1 1.1-1.1 1.1.5 1.1 1.1-.5 1.1-1.1 1.1z"
    />
    <path
      className="ico-deploy_svg__st0"
      d="M22.8 2s0-.1 0 0c-.1-.2-.1-.3-.2-.4-.1-.2-.3-.3-.5-.4h-.2c-.3-.1-.6-.1-1-.1-.2-.1-.6-.1-1-.1h-1.3c-.5 0-1 .1-1.5.2s-1 .2-1.5.4c-.3.2-.6.3-.8.4-.1 0-1 .5-2.8 1.7-1.3.9-2.5 2-3.6 3.3-.7-.1-1.8-.1-2.9.4-1.9.9-3.4 2.7-4.4 5.4-.1.3-.1.6 0 .9.1.3.4.4.7.5l2.9.7v.6c0 .3.1.5.3.7L7.9 19c.3.3.8.3 1.3.3l.7 2.9c.1.3.2.5.5.7.1.1.3.1.5.1.1 0 .2 0 .3-.1 2.7-1 4.5-2.5 5.4-4.4.5-1.2.5-2.2.5-2.9 1.3-1.1 2.4-2.3 3.3-3.6 1.2-1.8 1.7-2.8 1.7-2.8l.6-1.5.3-1.5c-.1-.4 0-.9 0-1.4V3.6c0-.3 0-.6-.1-.9 0-.2-.1-.5-.1-.7zm-1.9 1.1c.1 1.2.1 2.4-.1 3.5 0 .1 0 .2-.1.3V7L17 3.3c1.5-.4 3.1-.3 3.9-.2zM5.1 12.9l-1.7-.4c1.1-2.4 2.5-3.2 3.5-3.4-.3.5-.6 1-.9 1.6-.4.7-.7 1.5-.9 2.2zm6.4 7.7-.4-1.7c.7-.2 1.5-.5 2.2-.9.5-.3 1.1-.6 1.6-.9-.2 1-1 2.4-3.4 3.5zm1-4.4c-1.3.7-2.5 1-3.5 1.1L6.7 15s0-.3.1-.4c.2-1.1.6-2.1 1.1-3.1.5-1 1-1.9 1.7-2.8 0 0 0-.1.1-.1 1-1.3 2.2-2.4 3.5-3.3.9-.6 1.6-1 2-1.2L19.8 9c-.2.4-.6 1.1-1.2 2-1.4 2.1-3.6 3.9-6.1 5.2z"
    />
  </Icon>
);
export { SvgDeploy as Deploy };
